import React from "react";
import { connect } from "react-redux";

import cx from "classnames";
import PropTypes from "prop-types";
import { Switch, Route, withRouter } from "react-router-dom";
// creates a beautiful scrollbar
import PerfectScrollbar from "react-perfect-scrollbar";
import "perfect-scrollbar/css/perfect-scrollbar.css";

// @material-ui/core components
import withStyles from "@material-ui/core/styles/withStyles";

// core components
import AdminNavbar from "common/components/Navbars/AdminNavbar.jsx";
import NotificationNavbar from "common/components/Navbars/NotificationNavbar.jsx";
import Sidebar from "common/components/Sidebar/Sidebar.jsx";
import GlobalNotification from "common/components/GlobalNotification/GlobalNotification.js";
import ServiceEmailAddressesComponent from "views/Account/ServiceEmailAdresses.jsx";
import { connectedComponent } from "common/components/connectedComponent.js";

import Hidden from "@material-ui/core/Hidden";

import appStyle from "assets/jss/material-dashboard-pro-react/layouts/adminStyle.jsx";

import image from "assets/img/sidebar-2.jpg";
import logo from "assets/img/mcsnetLogo.png";
import store from "store";
import { addNewID } from "core-module/services/ids/actions";

import * as api from "core-module/services/api";
import ApiAlert from "../common/components/ApiAlert/ApiAlert.jsx";
import RootWrapper from "../rootWrapper.js";
import { isNativeIosPlatform } from "../deviceInfo";

import Dialog from "@material-ui/core/Dialog";
import DialogTitle from "@material-ui/core/DialogTitle";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogContentText from "@material-ui/core/DialogContentText";
import Button from "@material-ui/core/Button";

var ps;

class UserLayout extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      mobileOpen: false,
      miniActive: false,
      image: image,
      color: "blue",
      bgColor: "black",
      hasImage: true,
      fixedClasses: "dropdown",
      mainPanelRef: null,
      fwdDialog: false,
      acceptDialog: false,
    };

    this.resizeFunction = this.resizeFunction.bind(this);
  }

  componentDidMount() {
    api.get(`user.${this.props.activeUserId}/serviceemail`).then(({ list }) => {
      if (JSON.parse(window.sessionStorage.getItem("dismissedDialog"))) return;

      const acceptedFwdDialog = new Date(
        window.localStorage.getItem("acceptedFwdDialog")
      );
      const daysSinceAccepting = Math.floor(
        (new Date().getTime() - acceptedFwdDialog.getTime()) /
          (1000 * 3600 * 24)
      );

      if (daysSinceAccepting < 7) return;

      if (list)
        list.forEach((item) => {
          if (item.forwarding) {
            this.setState({ ...this.state, fwdDialog: true });
            return;
          }
        });
    });

    if (
      this.props.history.location.search !== null &&
      this.props.history.location.search.length > 0
    ) {
      //This was breaking myaccount CC add. I don't know how this happened. This ****** MIGHT  ****** break other stuff but really each consumer of GET params should also clean them up after using, so no need for the following lines in theory
      // this.props.history.push(
      //   this.props.history.location.pathname,
      //   this.props.history.location.state
      // );
    }
    if (navigator.platform.indexOf("Win") > -1) {
      // ps = new PerfectScrollbar(this.refs.mainPanel, );
      // document.body.style.overflow = "hidden";
    }
    this.setState({ ...this.state, mainPanelRef: this.refs.mainPanel });
    window.addEventListener("resize", this.resizeFunction);
  }
  componentWillUnmount() {
    if (navigator.platform.indexOf("Win") > -1 && ps != null) {
      // ps.destroy();
    }
    window.removeEventListener("resize", this.resizeFunction);
  }
  componentDidUpdate(e) {
    if (e.history.location.pathname !== e.location.pathname) {
      this.refs.mainPanel.scrollTop = 0;
      if (this.state.mobileOpen) {
        this.setState({ mobileOpen: false });
      }
    }
  }

  changeUser = (id) => {
    store.dispatch(addNewID("user", id));
  };
  handleImageClick = (image) => {
    this.setState({ image: image });
  };
  handleColorClick = (color) => {
    this.setState({ color: color });
  };
  handleBgColorClick = (bgColor) => {
    this.setState({ bgColor: bgColor });
  };
  handleFixedClick = () => {
    if (this.state.fixedClasses === "dropdown") {
      this.setState({ fixedClasses: "dropdown show" });
    } else {
      this.setState({ fixedClasses: "dropdown" });
    }
  };
  handleDrawerToggle = () => {
    this.setState({ mobileOpen: !this.state.mobileOpen });
  };
  getActiveRoute = (inputroutes) => {
    let usedRoutes;
    if (inputroutes == null) {
      usedRoutes = this.props.routes;
    } else {
      usedRoutes = inputroutes;
    }
    let activeRoute = "Welcome to MCSnet MyAccount";
    for (let i = 0; i < usedRoutes.length; i++) {
      if (usedRoutes[i].collapse) {
        let collapseActiveRoute = this.getActiveRoute(usedRoutes[i].views);
        if (collapseActiveRoute !== activeRoute) {
          return collapseActiveRoute;
        }
      } else if (usedRoutes[i].name === "bottomItems") {
        return this.getActiveRoute(usedRoutes[i].items);
      } else {
        if (
          window.location.href.indexOf(
            usedRoutes[i].layout + usedRoutes[i].path
          ) !== -1
        ) {
          return usedRoutes[i].name;
        }
      }
    }
    return activeRoute;
  };
  getRoutes = (inputroutes) => {
    let usedRoutes;
    if (inputroutes == null) {
      usedRoutes = this.props.routes;
    } else {
      usedRoutes = inputroutes;
    }
    return usedRoutes.map((prop, key) => {
      if (prop.collapse) {
        return this.getRoutes(prop.views);
      }
      if (prop.name === "bottomItems") {
        return this.getRoutes(prop.items);
      }
      const renderRoute = (routeProps) => {
        return (
          <prop.component
            {...routeProps}
            mainPanelRef={this.state.mainPanelRef}
          />
        );
      };
      return (
        <Route path={prop.layout + prop.path} render={renderRoute} key={key} />
      );
    });
  };
  sidebarMinimize() {
    this.setState({ miniActive: !this.state.miniActive });
  }
  resizeFunction() {
    if (window.innerWidth >= 960) {
      this.setState({ mobileOpen: false });
    }
  }

  render() {
    const { classes, ...rest } = this.props;
    const mainPanel =
      classes.mainPanel +
      " " +
      cx({
        [classes.mainPanelSidebarMini]: this.state.miniActive,
        [classes.mainPanelWithPerfectScrollbar]:
          navigator.platform.indexOf("Win") > -1,
      });

    let globalNotificationComp = null;
    let notificationNavBarComp = null;
    try {
      if (
        this.props.globalNotification != null &&
        window.localStorage.getItem(
          "globalNotification" + this.props.globalNotification.id
        ) == null
      ) {
        globalNotificationComp = (
          <GlobalNotification
            id={this.props.globalNotification.id}
            message={this.props.globalNotification.message}
          />
        );
      }
      if (
        this.props.warningActive &&
        this.getActiveRoute() !== "Important" &&
        this.getActiveRoute() !== "Package" &&
        (this.props.globalNotification == null ||
          window.localStorage.getItem(
            "globalNotification" + this.props.globalNotification.id
          ) != null)
      ) {
        notificationNavBarComp = (
          <div
            key="warningsnack"
            className={mainPanel}
            ref="notificationNavBar"
          >
            <NotificationNavbar />
          </div>
        );
      }
    } catch (e) {
      console.log(e.message);
    }

    const mainPanelContent = (
      <div className={mainPanel} ref="mainPanel">
        <AdminNavbar
          sidebarMinimize={this.sidebarMinimize.bind(this)}
          miniActive={this.state.miniActive}
          brandText={this.getActiveRoute()}
          handleDrawerToggle={this.handleDrawerToggle}
          userEmail={this.props.userEmail}
          {...rest}
        />
        <div className={classes.content}>
          <div className={classes.container}>
            <Switch>{this.getRoutes()}</Switch>
          </div>
          <Hidden mdUp implementation="css">
            <div className={classes.bottomUserEmail}>
              Logged as {this.props.userEmail}
            </div>
          </Hidden>
        </div>
      </div>
    );

    const handleCloseFwdDialog = (prop) => {
      if (prop === "accepted") {
        this.setState({ ...this.state, fwdDialog: false, acceptDialog: true });
        return;
      }

      this.setState({ ...this.state, fwdDialog: false });
    };

    const handleCloseAccDialog = () => {
      this.setState({ ...this.state, acceptDialog: false });
    };

    const handleRemindLater = () => {
      window.sessionStorage.setItem("dismissedDialog", true);
      handleCloseFwdDialog();
    };

    const handleAccept = () => {
      window.localStorage.setItem("acceptedFwdDialog", new Date());
      handleCloseFwdDialog("accepted");
      // this.props.history.push("account");
    };

    return (
      <RootWrapper>
        <div className={classes.wrapper}>
          <Dialog open={this.state.fwdDialog} onClose={handleCloseFwdDialog}>
            <DialogTitle>Cool new feature!</DialogTitle>
            <DialogContent>
              <DialogContentText>
                As most of our customers have started using other email
                providers, such as Gmail or Apple Mail, we're making it even
                easier to forward your email. Forward you email or delete emails
                you are no longer using here.
              </DialogContentText>
            </DialogContent>
            <DialogActions>
              <Button onClick={handleRemindLater}>Remind me later</Button>
              <Button onClick={handleAccept} color="primary">
                Let's go
              </Button>
            </DialogActions>
          </Dialog>
          <Dialog open={this.state.acceptDialog} onClose={handleCloseAccDialog}>
            <DialogContent>
              <ConnectedServiceEmailAddressesComponent
                compact={isNativeIosPlatform()}
                pathids={{ user: this.props.activeUserId }}
                loggedAs={this.props.userEmail}
              />
            </DialogContent>
            <DialogActions>
              <Button onClick={handleCloseAccDialog}>Close</Button>
            </DialogActions>
          </Dialog>
          <ApiAlert message={"Message"}></ApiAlert>
          <Sidebar
            associatedAccounts={this.props.associatedAccounts}
            userNames={this.props.associatedAccounts}
            routes={this.props.routes}
            userid={this.props.activeUserId}
            changeUser={this.changeUser}
            pathids={{ user: this.props.activeUserId }}
            logoText={""}
            logo={logo}
            image={this.state.image}
            handleDrawerToggle={this.handleDrawerToggle}
            open={this.state.mobileOpen}
            color={"primaryLightBlue"}
            bgColor={this.state.bgColor}
            miniActive={this.state.miniActive}
            {...rest}
          />
          {globalNotificationComp}
          {notificationNavBarComp}
          {navigator.platform.indexOf("Win") > -1 ? (
            <PerfectScrollbar
              options={{
                suppressScrollX: true,
                suppressScrollY: false,
              }}
            >
              {mainPanelContent}
            </PerfectScrollbar>
          ) : (
            <>{mainPanelContent}</>
          )}
        </div>
      </RootWrapper>
    );
  }
}

UserLayout.propTypes = {
  classes: PropTypes.object.isRequired,
};

const mapStateToProps = (state) => ({
  activeUserId: state.services.ids.user,
  userEmail: state.services.ids.email,
});

export default withStyles(appStyle)(
  withRouter(connect(mapStateToProps)(UserLayout))
);

const ConnectedServiceEmailAddressesComponent = connectedComponent(
  ServiceEmailAddressesComponent,
  {
    path: "user.id/serviceemail",
  }
);
